import { Route, Routes } from 'react-router-dom';
import RequestAdvance from './salary-advance/RequestAdvance';
import AdvanceStatus from './salary-advance/AdvanceStatus';

const SalaryAdvance = () => (
  <Routes>
    <Route index element={<RequestAdvance />} />
    <Route path="request" element={<RequestAdvance />} />
    <Route path="status" element={<AdvanceStatus />} />
  </Routes>
);

export default SalaryAdvance;
